<template>
  <div>
    <div v-if="isAuthenticated" class="tw-bg-gray-100 tw-relative tw-min-h-screen">
      <div class="tw-flex tw-flex-col tw-h-full md:tw-items-center tw-justify-center md:tw-mx-auto">
        <div class="tw-flex tw-justify-center ">
          <base-card shadow class="tw-overflow-hidden tw-w-full sm:tw-max-w-md sm:tw-mt-3 tw-h-full">
            <div class="tw-text-center tw-mb-4 tw-text-xl">You're all set!</div>
            <div class="tw-text-gray-700 tw-text-left tw-mb-3">Your subscriptions are active and your initial credits are in your account.</div>
            <div class="tw-text-gray-700 tw-text-center tw-mb-3"><strong>Enjoy your savings!</strong></div>
            <div class="tw-flex tw-justify-center tw-mt-4">
              <base-button type="primary" @click="href('/users/' + userId + '/plans')">View Savings Plans</base-button>
            </div>
          </base-card>
        </div>
      </div>
    </div>
    <div v-if="!isAuthenticated" class="tw-bg-gray-100 tw-relative tw-min-h-screen">
      <div class="tw-flex tw-flex-col tw-h-full md:tw-items-center tw-justify-center md:tw-mx-auto">
        <div class="tw-flex tw-justify-center ">
          <base-card shadow class="tw-overflow-hidden tw-w-full sm:tw-max-w-md tw-mt-3 tw-h-full">
            <div class="tw-text-center tw-mb-4 tw-text-xl">Boom! You're good to go.</div>
            <div class="tw-text-gray-700 tw-text-left tw-mb-3">
              Your {{ businessPlanName }} savings plan is active and your initial credits are in your account. Head to your email and confirm your address to secure your account.
              Once you do that, you're all set to log in.
            </div>

            <div class="tw-text-gray-700 tw-text-center tw-mb-3"><strong>Enjoy your savings!</strong></div>
            <div class="tw-flex tw-justify-center tw-mt-4">
              <base-button type="primary" @click="href('/signin')">Sign In</base-button>
            </div>
          </base-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    businessId: String,
  },
  data() {
    return {
      businessName: null,
      businessPlanName: null,
    };
  },
  computed: {
    ...mapGetters("cognito", { isAuthenticated: "isAuthenticated", userId: "id" }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
